import * as amplitude from '@amplitude/analytics-browser';
import { AnalyticsSource } from '../../types';
import { isDatadogSyntheticTest } from '../datadog';

export interface AmplitudeProps {
  key: string;
  options: Record<string, unknown>;
}

const isInitialized = (): boolean =>
  typeof window !== 'undefined' &&
  (window as any)?.ENV !== 'local' &&
  !isDatadogSyntheticTest();

export default {
  initialize: (props) => {
    amplitude.init(props.key, undefined, props.options);
  },
  trackEvent: (eventName, context) => {
    if (!isInitialized()) return;
    amplitude.track(eventName, context);
  },
} as AnalyticsSource<AmplitudeProps>;
